import { useNavigate } from "react-router-dom";
import { Button } from "@/components/Base/Button";

export const Forbidden = () => {
  const navigate = useNavigate();

  const onPressHome = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-grow flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-bold">403 - Forbidden</h1>
      <p>You do not have permission to access this page.</p>
      <Button onClick={onPressHome}>Go Home</Button>
    </div>
  );
};
